exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".accept-modal .container .jq-checkbox{display:inline-block;width:15px;height:15px;background:#fff;border-radius:2px;border:1px solid #979797}.accept-modal .container .jq-checkbox.checked{background:#3ec19d;border:1px solid #3ec19d}.accept-modal .container .jq-checkbox.checked:after{content:\"\";width:5px;height:12px;color:#fff;display:block;position:absolute;top:0;left:4px;border:2px solid #fff;border-left:none!important;border-top:none!important;transform:rotate(35deg)}@media (min-width:768px){.accept-modal .modal-dialog{width:537px;height:316px}}@media (max-width:768px){.accept-modal .modal-dialog{position:absolute;width:100vw;height:100vh;margin:0}.accept-modal .modal-dialog .modal-content{border:none;box-shadow:none}.accept-modal .modal-dialog .modal-content a.accept-close-popup,.accept-modal .modal-dialog .modal-content input.accept-send-mail{font-size:16px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/acceptRejectApplication/acceptApplication/acceptApplicationModal/acceptApplicationModal.css
// module id = 484
// module chunks = 0